import { DataHelpers } from "@/core/modules/helpers/DataHelpers";
import { LinkedDpi } from "@/features/modules/dpi/objects/LinkedDpi";

import { NumberField, ObjectField, StringField, StringStrictField } from "@/core/fields";

export class BoughtDpi {
  public id: string = DataHelpers.uniqueId();
  public dpi: LinkedDpi | undefined = undefined;
  public size: string | undefined = undefined;
  public unitPrice = 1;
  public quantity = 1;
  public totalPrice = 1;
  public order = 999;

  public constructor(firestoreData?: Record<string, unknown>) {
    if (firestoreData !== undefined) this.fromFirestore(firestoreData);
  }

  public fromFirestore(data: Record<string, unknown>): BoughtDpi {
    this.id = StringStrictField.fromFirestore(data.id, DataHelpers.uniqueId());
    this.dpi = ObjectField.fromFirestore<LinkedDpi>(data.dpi, (value) => new LinkedDpi(value));
    this.size = StringField.fromFirestore(data.size);
    this.unitPrice = NumberField.fromFirestore(data.unitPrice);
    this.quantity = NumberField.fromFirestore(data.quantity);
    this.totalPrice = NumberField.fromFirestore(data.totalPrice);
    this.order = NumberField.fromFirestore(data.order);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = {};

    firestoreData.id = StringStrictField.toFirestore(this.id);
    firestoreData.dpi = ObjectField.toFirestore<LinkedDpi>(this.dpi, (value) => value.toFirestore());
    firestoreData.size = StringField.toFirestore(this.size);
    firestoreData.unitPrice = NumberField.toFirestore(this.unitPrice);
    firestoreData.quantity = NumberField.toFirestore(this.quantity);
    firestoreData.totalPrice = NumberField.toFirestore(this.totalPrice);
    firestoreData.order = NumberField.toFirestore(this.order);

    return firestoreData;
  }
}
